import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-verification-send',
  templateUrl: './verification-send.component.html',
  styleUrls: ['./verification-send.component.css', '../forget-password/forget-password.component.css']
})
export class VerificationSendComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
